import { copyOnClipboard, openLastUpdatesWindow, checkForUpdates } from './utils';
import Form from './forms';
import DateUtils from './utils/DateUtils';
import FormUtils from './utils/FormUtils';
import NavigationUtils from './utils/NavigationUtils';
import MerideVideo from './utils/MerideVideo';
import { CrudAction, CopyAction } from './enums';
import Switchery from 'switchery';
import 'summernote/src/lang/summernote-it-IT';
import './vcdn-processing';
import { initPeriodDatepickerFilters } from './components/PeriodDatepickerFilter';

toastr.options = {
	positionClass: 'toast-bottom-left',
};

window.Utils = {
	LoaderShow: NavigationUtils.LoaderShow,
	LoaderHide: NavigationUtils.LoaderHide,
	createAndOpenPanel: NavigationUtils.createAndOpenPanel,
	openLastUpdatesWindow: openLastUpdatesWindow,
	copyOnClipboard: copyOnClipboard,
};

$.extend(true, $.magnificPopup.defaults, {
	tClose: 'Chiudi (Esc)', // Alt text on close button
	tLoading: 'Caricamento in corso...', // Text that is displayed during loading. Can contain %curr% and %total% keys
	gallery: {
		tPrev: 'Precedente (Freccia sinistra)', // Alt text on left arrow
		tNext: 'Successivo (Freccia destra)', // Alt text on right arrow
		tCounter: '%curr% di %total%', // Markup for "1 of 7" counter
	},
	image: {
		tError: 'Immagine non caricata.', // Error message when image could not be loaded
	},
	ajax: {
		tError: 'Contenuto non caricato.', // Error message when ajax request failed
	},
});

window.addEventListener('unload', () => {
	NavigationUtils.LoaderShow();
	// if (navigator.sendBeacon) {
	// 	const url = window.appconfig.routes.yourEndpoint || '/api/your-endpoint';
	// 	navigator.sendBeacon(url);
	// } else {
	// 	// Fallback for older browsers
	// 	const xhr = new XMLHttpRequest();
	// 	xhr.open('POST', url, false); // synchronous request
	// 	xhr.setRequestHeader('Content-Type', 'application/json');
	// 	xhr.send();
	// }
});

$(function () {
	// inizializzazione campi switch
	const elems = document.querySelectorAll('input[data-plugin="switchery"], input[data-switchery]');
	for (let i = 0; i < elems.length; i++) {
		const elem = elems[i];
		const size = elem.getAttribute('data-size') || 'default';
		new Switchery(elem, {
			size: size,
			color: 'var(--primary)',
			secondaryColor: 'var(--gray)',
		});
	}

	window.form = $('#pageForm').length ? new Form() : null;

	$('#openMenuForMobile').on('click', function () {
		if ($('body').hasClass('site-menubar-hide')) {
			$('body').removeClass('site-menubar-hide').addClass('site-menubar-unfold');
		} else {
			$('body').removeClass('site-menubar-unfold').addClass('site-menubar-hide');
		}
	});

	$('[rel=tooltip]').tooltip({ boundary: 'window' });
	$('[rel=tooltip-offset]').tooltip({ boundary: 'window', offset: '0, 13' });

	// GESTIONE COMUNE CAMPI FORMS DI TIPO DATA
	$('[data-no-date]').on('click', function () {
		const field = document.getElementById(this.getAttribute('data-field-identifier'));
		DateUtils.getFlatPickr(field).clear();
	});
	$('[data-current-date]')
		.on('click', function () {
			const field = document.getElementById(this.getAttribute('data-field-identifier'));
			DateUtils.timeSync(field);
			const clock = $(this).find('i')[0];
			DateUtils.replaceClockIcon(clock, field.value.split(' al ')[0]);
			// splitto nel caso dei date range di datepickr
		})
		.on('change', () => {
			const field = document.getElementById(this.getAttribute('data-field-identifier'));
			DateUtils.replaceClockIcon(clock, field.value.split(' al ')[0]);
		});
	$('[data-inputmask]').each((_idx, el) => {
		DateUtils.getFlatPickr(el);
	});

	initPeriodDatepickerFilters();

	// gestione campi copia valore
	$(document).on('click', '[data-copy]', function (e) {
		e.preventDefault();

		// Copia sempre negli appunti
		copyOnClipboard(this);

		// In iframe/popup (es. selezione video VCDN): non fare stopPropagation,
		// così il handler successivo può inviare postMessage set-url al parent
		if (window.self !== window.top) {
			return;
		}
		e.stopPropagation();

		return false;
	});

	$(document).on('click', '[data-download]', function (e) {
		e.preventDefault();
		e.stopPropagation();
		const url = $(e.currentTarget).attr('data-download');
		if (!url.length) return false;

		window.form?.clearConfirmPageLeave();
		location.href = window.appconfig.routes.files.download + '?url=' + encodeURIComponent(url);
		if (window.needsConfirm) {
			window.form?.setConfirmPageLeave();
		}

		return false;
	});

	// initializzazione bottone dettaglio tabelle

	// Controllo chiusura popup
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get('popup') === 'true' || window.self !== window.top) {
		window.addEventListener('message', function (event) {
			if (event.data === 'requestClose') {
				if (window.needsConfirm) {
					window.parent.postMessage('preventClose', '*');
					console.info('postMessage: prevent close');
				} else {
					const unlock = $('#unlockurl');
					if (unlock.length) {
						NavigationUtils.LoaderShow();
						if (window.pollingInterval) {
							clearInterval(window.pollingInterval);
							pollingInterval = null;
							if (window.pollingCall) {
								window.pollingCall.abort("Annullato dall'utente");
								window.pollingCall = null;
							}
						}
						$.ajax(unlock.val()).then(() => {
							window.parent.postMessage('allowClose', '*');
							console.info('postMessage: allow close');
						});
					} else {
						window.parent.postMessage('allowClose', '*');
						console.info('postMessage: allow close');
					}
				}
			} else if (event.data === 'pong') {
				window.dispatchEvent(new Event('handshakeDone'));
			} else if (event.data === 'changelogUpdated') {
				console.info('postMessage: changelog updated');
				checkForUpdates();
			} else if (event.data.action === 'setNeedsConfirm') {
				window.form.needsConfirm = event.data.value;
			}
		});

		window.parent.postMessage('ping', '*');
		console.info('Inizializzato protocollo risposta a requestClose');

		const pageTitleMeta = document.querySelector('meta[name="page-title"]');
		if (pageTitleMeta && pageTitleMeta.content) {
			window.parent.postMessage({ action: 'set-title', title: pageTitleMeta.content }, '*');
		}
	}

	if (window.self !== window.top) {
		// inietta il flag popup nell'url se è un redirect interno ad un iframe
		$('a[href]:not(.popup-preview-image):not(.popup-preview-gallery-image)').each((_idx, el) => {
			const href = el.getAttribute('href');
			if (!href.includes('popup=true')) {
				el.setAttribute('href', href + (el.href.includes('?') ? '&' : '?') + 'popup=true');
			}
		});

		const action = urlParams.get('action');
		if (action) {
			$(`.action-button:not([data-action="${action}"]):not([data-action="${CrudAction.STAMP}"])`).hide();
			$('.actions .btn-group:has(.dropdown-menu):not(:has(.dopdown-item:visible))').hide();
		}

		$(document).on('click', '[data-copy]', function () {
			const $button = $(this);
			const buttonAction = $button.attr('data-action');
			const thumbUrl = $button.attr('data-copy-thumb') || null;

			// Se c'è un parametro 'action' nell'URL che specifica quale tipo di contenuto stiamo inserendo
			if (action) {
				// Se l'action è VIDEO e clicco sull'immagine, devo comunque inserire il video
				if (action === CopyAction.VIDEO && buttonAction === CopyAction.IMAGE) {
					// Cerca il pulsante video corrispondente (stesso data-id)
					const $videoButton = $(`[data-copy][data-action="${CopyAction.VIDEO}"][data-id="${$button.attr('data-id')}"]`);
					if ($videoButton.length > 0) {
						// Invia il video come URL principale e l'immagine come secondario
						window.parent.postMessage({ action: 'set-url', url: $videoButton.attr('data-copy'), buttonAction: CopyAction.VIDEO }, '*');
						window.parent.postMessage({ action: 'set-secondary-url', url: $button.attr('data-copy') }, '*');
					}
					return; // L'immagine è già stata copiata negli appunti dall'handler precedente
				}

				// In tutti gli altri casi con action, conferma solo se il buttonAction corrisponde
				if (action === buttonAction) {
					window.parent.postMessage({ action: 'set-url', url: $button.attr('data-copy'), thumb: thumbUrl, buttonAction: buttonAction }, '*');
					$('[data-copy]').each(function () {
						if ($button.attr('data-action') === $(this).attr('data-action') && $button.attr('data-id') === $(this).attr('data-id')) {
							$(this).toggleClass('selected', true);
						} else {
							$(this).toggleClass('selected', false);
						}
					});

					// Se stiamo confermando un video, invia anche l'immagine come URL secondario
					if (buttonAction === CopyAction.VIDEO) {
						const $siblings = $button.siblings(`[data-action="${CopyAction.IMAGE}"]`);
						if ($siblings.length > 0 && $siblings[0].getAttribute('data-copy') !== '') {
							window.parent.postMessage({ action: 'set-secondary-url', url: $siblings[0].getAttribute('data-copy') }, '*');
						}
					}
				}
			} else {
				// Nessun action specificato: comportamento predefinito (conferma tutto)
				window.parent.postMessage({ action: 'set-url', url: $button.attr('data-copy'), thumb: thumbUrl, buttonAction: buttonAction }, '*');
				$('[data-copy]').each(function () {
					if ($button.attr('data-action') === $(this).attr('data-action') && $button.attr('data-id') === $(this).attr('data-id')) {
						$(this).toggleClass('selected', true);
					} else {
						$(this).toggleClass('selected', false);
					}
				});

				// Se stiamo confermando un video, invia anche l'immagine come URL secondario
				if (buttonAction === CopyAction.VIDEO) {
					const $siblings = $button.siblings(`[data-action="${CopyAction.IMAGE}"]`);
					if ($siblings.length > 0 && $siblings[0].getAttribute('data-copy') !== '') {
						window.parent.postMessage({ action: 'set-secondary-url', url: $siblings[0].getAttribute('data-copy') }, '*');
					}
				}
			}
		});
	}

	window.addEventListener(
		'message',
		function (event) {
			if (event.origin != this.location.origin) {
				return;
			}
			switch (event.data) {
				case 'closeup':
					$('#panel #close-popup').trigger('click');
					break;
			}
		},
		false,
	);

	FormUtils.initializeSelect2('#impersonate', false, 'auto', false, null, false, {
		ajax: {
			url: window.appconfig.routes.journalists.impersonate,
		},
	});

	let userFiltersChanged = false;
	if ($('#filtersForm').length) {
		$('#filtersForm').on('change', function () {
			userFiltersChanged = true;
		});

		window.addEventListener('keyup', function (e) {
			if (e.key === 'Enter' && userFiltersChanged) {
				$('#filtersForm').trigger('submit');
			}
		});
	}

	$('button[data-current-date]').each(function () {
		const field = $('#' + $(this).attr('data-field-identifier'));
		const clock = $(this).find('i')[0];
		DateUtils.replaceClockIcon(clock, field.val().split(' al ')[0]);
		// splitto nel caso dei date range di datepickr
		field.on('change', () => DateUtils.replaceClockIcon(clock, field.val().split(' al ')[0]));
	});

	$('.popup-preview-image').magnificPopup({
		type: 'image',
		closeOnContentClick: true,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		image: {
			verticalFit: true,
			titleSrc: function (item) {
				return item.el.attr('title') ?? '';
			},
		},
		zoom: {
			enabled: true,
		},
		gallery: {
			enabled: true,
		},
	});

	$('.popup-preview-gallery').each(function () {
		$(this).magnificPopup({
			delegate: '.popup-preview-gallery-image',
			type: 'image',
			closeOnContentClick: true,
			closeBtnInside: false,
			mainClass: 'mfp-with-zoom mfp-img-mobile',
			image: {
				verticalFit: true,
				titleSrc: function (item) {
					return item.el.attr('title') ?? '';
				},
			},
			zoom: {
				enabled: true,
			},
			gallery: {
				enabled: true,
			},
		});
	});

	$('.popup-preview-iframe').magnificPopup({
		type: 'inline',
		closeOnContentClick: true,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		zoom: {
			enabled: true,
		},
		gallery: {
			enabled: true,
		},
	});

	$('.popup-preview-video').magnificPopup({
		type: 'iframe',
		closeOnContentClick: false,
		closeBtnInside: false,
		mainClass: 'mfp-with-zoom mfp-img-mobile',
		zoom: {
			enabled: true,
		},
		gallery: {
			enabled: false,
		},
		callbacks: {
			elementParse: function (item) {
				const videoType = item.el.attr('data-video-type');
				if (videoType === 'video') {
					item.type = 'inline';
					const videoUrl = item.el.attr('href');
					item.src = `<div class="mfp-video-container" style="max-width: 900px; margin: 0 auto; background: #000;">
						<video controls autoplay style="width: 100%; max-height: 80vh;">
							<source src="${videoUrl}" type="video/mp4">
							Il tuo browser non supporta il tag video.
						</video>
					</div>`;
				} else if (videoType === 'meride') {
					item.type = 'inline';
					const customer = item.el.attr('data-meride-customer') || window.merideCustomerId;
					const code = item.el.attr('data-meride-code');
					const { html, containerId } = MerideVideo.createPopupContainer(customer, code);
					item.src = html;
					MerideVideo.initPopupPlayer(containerId, customer, code);
				}
			},
			close: function () {
				const video = document.querySelector('.mfp-video-container video');
				if (video) {
					video.pause();
					video.src = '';
				}
				MerideVideo.cleanupPopupPlayers();
			},
		},
	});

	$(document).on('click', '.timeline-item a', function () {
		const li = $(this).parent('li');
		const id = li.attr('data-id');
		const entity = li.attr('data-entity');
		if (!id) return;

		if ($('[data-toggle="offcanvas"][data-id="' + id + '"]').length) {
			console.info('found element, triggering show details');
			$('[data-toggle="offcanvas"][data-id="' + id + '"]').trigger('click');
			$('.offcanvas-body').animate({ scrollTop: 0 });
		} else {
			console.info('no element found, redirecting to correct page');
			const $btn = $('<button>').attr('data-id', id).attr('data-entity', entity).attr('data-toggle', 'offcanvas').attr('type', 'button');
			document.dispatchEvent(new CustomEvent('openOffcanvas', { detail: { data: { entity, id, action: 'children' }, btn: $btn } }));
		}
	});

	// Previeni il comportamento di default del browser
	$(document).on('dragover drop', function (e) {
		e.preventDefault();
	});

	checkForUpdates();

	const filters = $('#filtersForm');
	if (filters.length) {
		let resizeTimer = null;
		const dynamicContainer = filters.find('.dynamic-filters-container');

		if (dynamicContainer.length) {
			const filtersItems = filters.find('.d-flex.flex-column');
			if (filtersItems.length === 0) return;
			filtersItems.each((idx, el) => $(el).css('order', idx));

			const hiddenFieldsContainer = $('#hidden-fields-container');
			const hiddenFieldsDropdownList = hiddenFieldsContainer.find('.dropdown ul');
			const allFiltersContainer = filters.find('.filter-fields-container');

			const defaultButtonSize = 40;
			const defaultFilterSize = 155;
			let defaultQFilterSize = allFiltersContainer.find('.q-filter').get(0).style.minWidth || 200;
			defaultQFilterSize = parseInt(defaultQFilterSize);

			filtersItems.each(function (_idx, el) {
				if (el.classList.contains('hidden-filter')) {
					$(el).detach();
					hiddenFieldsDropdownList.append(el);
				}
			});

			function redrawFilters() {
				const currentlyVisible = dynamicContainer.children();
				const movableFilters = currentlyVisible
					.filter((_idx, item) => !item.classList.contains('fixed-filter'))
					.sort((a, b) => a.style.order - b.style.order);
				// const currentlyHidden = hiddenFieldsDropdownList.children();
				const showableFilters = /*currentlyHidden*/ hiddenFieldsDropdownList
					.children()
					.filter((_idx, item) => !item.classList.contains('hidden-filter'));
				const totalFilters = currentlyVisible.length + showableFilters.length;

				const singleFilterSize = Math.ceil(currentlyVisible.get(0)?.getBoundingClientRect().width || defaultFilterSize);
				const allFiltersContainerWidth = Math.ceil(allFiltersContainer.get(0).getBoundingClientRect().width);
				// 40px è circa la dimensione del bottone dei filtri nel caso debba comparire, lo considero sempre come visibile
				// 200px è la larghezza minima del campo di ricerca
				const availableContainerSize = allFiltersContainerWidth - defaultQFilterSize - defaultButtonSize;
				// su desktop mostro il numero di filtri che possono essere visibili, su mobile li nascondo sempre tutti
				let mustBeVisible = window.innerWidth > 768 ? Math.min(Math.floor(availableContainerSize / singleFilterSize), totalFilters) : 0;
				if (movableFilters.length > 0) {
					mustBeVisible = Math.max(mustBeVisible, movableFilters.length);
				}

				const mustBeHidden = totalFilters - mustBeVisible;

				if (currentlyVisible.length > mustBeVisible && movableFilters.length > 0) {
					const detached = movableFilters.slice(-mustBeVisible).detach();
					hiddenFieldsDropdownList.prepend(detached);
				} else if (showableFilters.length > mustBeHidden) {
					const detached = showableFilters.slice(0, showableFilters.length - mustBeHidden).detach();
					dynamicContainer.append(detached);
				}

				if (hiddenFieldsDropdownList.children().length > 0) {
					if (hiddenFieldsContainer.hasClass('d-none')) {
						hiddenFieldsContainer.removeClass('d-none').addClass('d-flex');
					}
				} else {
					if (hiddenFieldsContainer.hasClass('d-flex')) {
						hiddenFieldsContainer.removeClass('d-flex').addClass('d-none');
					}
				}
			}

			redrawFilters();

			window.addEventListener('resize', () => {
				if (resizeTimer) {
					clearTimeout(resizeTimer);
				}
				resizeTimer = setTimeout(() => {
					redrawFilters();
				}, 200);
			});
		}

		$(document).on(
			'click mousedown',
			'#hidden-fields-container .dropdown-menu .select2-container, #hidden-fields-container .dropdown-menu .select2-search__field, #hidden-fields-container .dropdown-menu .select2-results__option',
			function (e) {
				e.stopPropagation();
			},
		);

		// Impedisce che l'interazione con i filtri Select2 chiuda la dropdown dei filtri nascosti
		$('#hidden-fields-container .dropdown').on('hide.bs.dropdown', function (e) {
			const clickEvent = e.clickEvent || e.relatedTarget?.clickEvent;
			if (!clickEvent) {
				// chiusure programmatiche o da tastiera le lasciamo passare
				return;
			}

			const $target = $(clickEvent.target);

			// Se il click arriva:
			// - da dentro il menu dropdown (label, select, ecc.)
			// - oppure da un elemento Select2 (contenitore o dropdown delle opzioni)
			// allora non chiudiamo la dropdown dei filtri nascosti.
			if (
				$target.closest('#hidden-fields-container .dropdown-menu').length ||
				$target.closest('.select2-container').length ||
				$target.closest('.select2-dropdown').length
			) {
				e.preventDefault();
			}
		});
	}

	$('#impersonate').on('change', function (evt) {
		$(this).siblings('.btn').removeClass('disabled');
	});
});
